export default "__VITE_ASSET__84287846__"